module.exports = __webpack_public_path__ + "static/media/forall.ac1c8be7.jpg";